import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type TimeInputProps, TimeInput } from '../TimeInput';

type FormTimeInputProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  TimeInputProps;

function FormTimeInput<TFieldValues extends FieldValues = FieldValues>(
  props: FormTimeInputProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <TimeInput
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText}
      required={Boolean(props.rules?.required ?? props.required)}
      ref={ref}
      onChange={(value) => {
        field.onChange(value);
        props.onChange?.(value);
      }}
    />
  );
}

export type { FormTimeInputProps };
export { FormTimeInput };
